module.exports = __webpack_public_path__ + "img/cm-turneele-in-sua.c85fe1a9.jpg";